import { render, staticRenderFns } from "./salaryTaxList.vue?vue&type=template&id=3f92acc6&scoped=true&"
import script from "./salaryTaxList.vue?vue&type=script&lang=js&"
export * from "./salaryTaxList.vue?vue&type=script&lang=js&"
import style0 from "./salaryTaxList.vue?vue&type=style&index=0&id=3f92acc6&scoped=true&lang=css&"
import style1 from "./salaryTaxList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f92acc6",
  null
  
)

export default component.exports